import React, { useState } from "react";
import { FormProvider } from "react-hook-form";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import Step1 from "./steps/Step1/index";
import Step2 from "./steps/Step2/index";
import Step3 from "./steps/Step3/index";

const steps = [Step1, Step2, Step3];

const Wizard = ({ methods }: any) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const CurrentStep = steps[step];

  return (
    <FormProvider {...methods}>
      <div className="bg-white rounded-md shadow flex flex-col justify-between w-full h-full p-2">
        <div className={"flex flex-col flex-1 overflow-auto mb-2"}>
          <CurrentStep />
        </div>

        <div className="flex justify-between items-center">
          <Button disabled={step === 0} onClick={() => setStep((s) => s - 1)}>
            {t("back")}
          </Button>
          <Button
            variant="contained"
            onClick={() =>
              step === steps.length - 1
                ? methods.handleSubmit(console.log)()
                : setStep((s) => s + 1)
            }
          >
            {step === steps.length - 1 ? t("submit") : t("next")}
          </Button>
        </div>
      </div>
    </FormProvider>
  );
};

export default Wizard;
